import type { TrackEventResponse } from "@/services/loyalty/types";
import type { ToastNotificationManager } from "@/ui/toast-notification-manager";
import type { SDKState } from "@/state/sdk-state";

export function showLoyaltyToastNotification(
  manager: ToastNotificationManager,
  props: TrackEventResponse,
  state: SDKState,
) {
  if (!props.notificationMessage) {
    return;
  }

  function navigateToScore() {
    window.open(`${state.options.appOrigin}`);
  }

  function triggerAuthentication() {
    state.options.hostLoginFn?.();
  }

  const actionLabel = state.authState.isAuthenticated
    ? "View Score"
    : "Claim Rewards";
  const actionCallback = state.authState.isAuthenticated
    ? navigateToScore
    : triggerAuthentication;

  return manager.show({
    message: props.notificationMessage,
    actionCallback,
    actionLabel,
    points: props.points,
    duration: 5000,
    persistent: false,
  });
}
